import systemService from "./SystemService";
import securityService from "./SecurityService";
import crApi from "./CrApi";

class TaskHelperService {
    public taskInstances = [];
    public modalTask = null;
    public modalVisible = false;
    public inboxVisible = false;
    public lastReloadTs = null;
    public taskConstants = null;
    public onModalClose = [];
    public modalPlaceholder = '';
    public taskInstancesInProgress = [];
    public showTasksInInbox = true;
    public isProcessingTasks = false;
    public instancesInProgressCount = 0;
    public instancesCount = 0;

    public constructor() {
        (async () => {


            crApi.requestV2('task/retrieve_constants/', {website_token: securityService.getToken()}).then((constants) => {
                this.taskConstants = constants;
            });

            systemService.taskHelper = this;

            // TODO: HOW TO WATCH IN VUE???
            /* Added in AppPage
            /*this.$rootScope.$watch('taskHelper.modalTask', (newValue, oldValue) => {
                this.modalVisible = this.modalTask != null;
            });
            this.$rootScope.$watch('taskHelper.modalPlaceholder', (newValue, oldValue) => {
                if (newValue !== '') {
                    this.modalVisible = true;
                }
            });

            this.$rootScope.$watch('taskHelper.modalVisible', (newVal, oldVal) => {
                if (this.modalVisible == false) {
                    this.modalTask = null;
                }

                if (newVal == false && oldVal == true) {
                    this.modalPlaceholder = '';
                    _.forEach(this.onModalClose, (f) => {
                        this.$timeout(f, 1000);
                    });
                    this.onModalClose = [];
                }
            });
            /* Added in AppPage End

            this.$rootScope.$watch('taskHelper.inboxVisible', () => {
                if (this.inboxVisible) {
                    this.showTasksInInbox = this.taskInstances.length != 0;
                }
            });*/

            await this.getInProgressTasks();
        })();
    }


    public async init() {
        //this.showModal(243);
        await this.reload();

        setInterval(async () => {

            let ts = Math.round((new Date()).getTime() / 1000);

            let reloadInterval = 2 * 60;
            if (this.modalTask != null || this.inboxVisible) {
                reloadInterval = 10;
            }

            if (this.lastReloadTs == null || ts - this.lastReloadTs >= reloadInterval) {
                this.lastReloadTs = ts;
                await this.reload();
            }
        }, 1000);
    };

    public async getInProgressTasks() {
        const router = (await import('../router')).default;
        if (router.currentRoute.value.name  == '' || !router.currentRoute.value.name) {
            return;
        }
        if (router.currentRoute.value.name.substring(0, 5) == 'aayor' || router.currentRoute.value.name.substring(0, 10) == 'attendance'
            || router.currentRoute.value.name.substring(0, 10) == 'userportal' || router.currentRoute.value.name.substring(0, 10) == 'checkinout') {
            return;
        }

        this.isProcessingTasks = true;
        const params = {
            'response': 'extra',
            'filter': 'inbox',
            'completionStatus': [0,2,3],
            'limit': 11,
            'website_token': securityService.getToken()
        };
        return await crApi.requestV2('task/retrieve_history/', params).then((response) => {
            return new Promise<void>((resolve, reject) => {
                if (response.error) {
                    reject();
                    return;
                }
                this.taskInstancesInProgress = response.historyItems;
                this.instancesInProgressCount = this.taskInstancesInProgress.length;

                if (this.taskInstancesInProgress.length == 11) {
                    this.taskInstancesInProgress = this.taskInstancesInProgress.splice(0, this.taskInstancesInProgress.length - 1);
                }
                this.isProcessingTasks = false;
                resolve();
            });
        })

    };

    public async reload() {
        if (!securityService.isAuthenticated()) {
            return;
        }
        const router = (await import('../router')).default;
        if (router.currentRoute.value.name  == '' || !router.currentRoute.value.name) {
            return;
        }
        if (router.currentRoute.value.name.substring(0, 5) == 'aayor' || router.currentRoute.value.name.substring(0, 10) == 'attendance' ||
            router.currentRoute.value.name.substring(0, 10) == 'userportal' || router.currentRoute.value.name.substring(0, 10) == 'checkinout') {
            return;
        }
        const params = {
            'response': 'extra',
            'filter': 'inbox',
            'limit': 11,
            'website_token': securityService.getToken()
        };

        if (this.inboxVisible) {
            params['completion_status'] =  [1,4,5];
        }
        return await crApi.requestV2('task/retrieve_history/', params).then((response) => {
            return new Promise<void>((resolve, reject) => {
                if (response.error) {
                    reject();
                    return;
                }
                this.taskInstances = response.historyItems;
                this.instancesCount = this.taskInstances.length;

                if (this.taskInstances.length == 11) {
                    this.taskInstances = this.taskInstances.splice(0, this.taskInstances.length - 1);
                }

                for (let instance of this.taskInstances) {
                    if (this.modalTask) {
                        if (this.modalTask['historyId'] == instance['historyId']) {
                            this.modalTask = instance;
                            return false;
                        }
                    }
                }
                resolve();
            })
        });
    };

    public showModal(taskId, onClose = undefined) {
        if (typeof onClose === 'function') {
            this.onModalClose.push(onClose);
        }

        this.inboxVisible = false;
        if (this.modalTask != null && this.modalTask['historyId'] == taskId) {
            return;
        }
        this.reload().then(() => {
            for (let instance of this.taskInstances) {
                if (instance.historyId == taskId) {
                    this.modalTask = instance;
                }
            }
        });
    };

    public hideModal() {
        this.modalVisible = false;
        this.modalTask = null;

    };

    public async cancelTask(taskId) {
         await crApi.requestV2('task/cancel_history_item/', {historyId: taskId, website_token: securityService.getToken()});
         await this.getInProgressTasks();
         await this.reload();
    };

    public async dismissTask(taskId) {
        await crApi.requestV2('task/dismiss_history/', {website_token: securityService.getToken(), historyId: taskId});
        await this.getInProgressTasks();
        await this.reload();
    };

    public async dismissAll(instances) {
        const instanceIds = [];
        for (let instance of instances) {
            instanceIds.push(instance['historyId']);

        }
        await this.dismissTask(instanceIds);
    };

    public getName(type) {
        let name = type;
        if (this.taskConstants) {
            for (let k in this.taskConstants.types) {
                if (k == type) {
                    name = this.taskConstants.types[k];
                }
            }
        }
        return name;
    };

    public navigateToHistory() {
        this.inboxVisible = false;
        setTimeout(() => {
            //this.$state.go('app.tasks.index.instance', {page: 1, active: 'all'});
            window.location.href = '/account/tasks/listing/instance/?page=1&active=all';
        }, 1000);
    };

    public async downloadFile(instanceId, taskType) {
        if (taskType == "generatebarcode") {
            let checkResponse =  await crApi.requestV2('barcode/download/', {isCheck: 1, historyId: instanceId, website_token: securityService.getToken()});
            if (checkResponse.status == 1) {
                let params = {
                    historyId: instanceId,
                    website_token: securityService.getToken()
                };
                window.location.href = window.location.protocol + "//" + window.location.host +
                    "/api-v2/barcode/download/?params="+JSON.stringify(params);

            }

        } else if (taskType == "downloadscan") {
            let checkResponse = await crApi.requestV2('task/download/', {isCheck: 1, historyId: instanceId, website_token: securityService.getToken()});
            if (checkResponse.status == 1) {
                let params = {
                    historyId: instanceId,
                    website_token: securityService.getToken()
                };
                window.location.href = window.location.protocol + "//" + window.location.host +
                    "/api-v2/task/download/?params="+JSON.stringify(params);
            }
        } else {
            let checkResponse = await crApi.requestV2('task/download/', {isCheck: 1, historyId: instanceId, website_token: securityService.getToken()});
            if (checkResponse.status == 1) {
                let params = {
                    historyId: instanceId,
                    website_token: securityService.getToken()
                };
                window.location.href = window.location.protocol + "//" + window.location.host +
                    "/api-v2/task/download/?params="+JSON.stringify(params);
            }
        }
    }
}

export default new TaskHelperService();
